module.exports = __webpack_public_path__ + "static/media/icon_menu_analysis_disabled.0f395351.svg";